import { render, staticRenderFns } from "./ProofreadProblemInput.vue?vue&type=template&id=6f938abc&scoped=true&lang=pug&"
import script from "./ProofreadProblemInput.vue?vue&type=script&lang=ts&"
export * from "./ProofreadProblemInput.vue?vue&type=script&lang=ts&"
import style0 from "./ProofreadProblemInput.vue?vue&type=style&index=0&id=6f938abc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f938abc",
  null
  
)

export default component.exports